import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';
import _ from 'lodash';
import { clientUnitToServerMap } from 'app/businessRules';
import { loadDataAction,loadDataDoneAction,loadDataErrorAction } from 'modules/app/actions';
import { verifyUnit as verifyUnitActions } from '../actions';
import { VERIFY_UNIT } from '../constants/actionTypes';
import * as api from '../repository';



function *_verifyUnit(action) {
    const {unit, dom} = action;
    yield put(loadDataAction('verifyUnit'));
    let payload = clientUnitToServerMap(unit);
    payload.dom = dom;

    try {
        let response = yield call(api.verifyUnit(payload));
        yield put(verifyUnitActions.success(response));
        yield put(loadDataDoneAction('verifyUnit'));
    } catch (error) {
        yield put(verifyUnitActions.error(error));
        yield put(loadDataErrorAction('verifyUnit', {response: error.response, body: error.body, titleId:'unit.form.verify.failed'}, action));
    }

}


export function *verifyUnit() {
    yield takeLatest(VERIFY_UNIT.REQUEST, _verifyUnit);
}